import { IApplicationState } from '../../types/redux';

export function selectOtp(state: IApplicationState) {
  return state.otp.otp;
}
